import { render, staticRenderFns } from "./PermissionsGranter.vue?vue&type=template&id=5107c160"
import script from "./PermissionsGranter.vue?vue&type=script&lang=ts"
export * from "./PermissionsGranter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports